import {Pipe} from '@angular/core';
import {DatePipe} from '@angular/common';
import moment from 'moment-timezone';
import {environment} from '../../../environments/environment';

@Pipe({
  name: 'localToUtc'
})
/** @deprecated Prefer `toUtcForApi` from `shared/datetime/datetime-boundary` in services (AC-40). */
export class LocalToUtcPipe extends DatePipe {

  override transform(value: string, format?: string): any {

    if (value && moment(value).isValid()) {

      const utcOffset = moment().utcOffset();
      const dateToDisplay = moment(value).add(utcOffset - (utcOffset * 2), 'minutes');
      return dateToDisplay.format(format || environment.dateTimeFormat);
    }
    return value;
  }
}
